export default __webpack_public_path__ + "static/media/13.e2931365.png";